import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListAdminStaf, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import AccountResetEmail from "../../pagesSub/accountUser/AccountResetEmail";
import AccountResetUsernamePassword from "../../pagesSub/accountUser/AccountResetUsernamePassword";

const AccountAS = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListAdminStaf.account.slug;
    const roleUser = role.admin;
    const slugLink = roleUser.subLevel.admin_staf.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListAdminStaf}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListAdminStaf.account.subMenu.one.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListAdminStaf.account.subMenu.one.tabs.one.flag}>
                                {menuListAdminStaf.account.subMenu.one.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListAdminStaf.account.subMenu.one.tabs.two.flag}>
                                {menuListAdminStaf.account.subMenu.one.tabs.two.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListAdminStaf.account.subMenu.one.tabs.one.flag}>
                            <AccountResetEmail />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListAdminStaf.account.subMenu.one.tabs.two.flag}>
                            <AccountResetUsernamePassword />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default AccountAS;